/* Journey design tokens — directive §14. */
export const J = {
  card: "#FFFFFF", edge: "#DAD5CA", head: "#FBFAF7", rule: "#EFECE4",
  ink: "#1A1A1A", ink2: "#59554D", muted: "#8A857C",
  overdue: "#C23A00", overdueFill: "#FFE9E0", overdueInk: "#9A3200", overdueEdge: "#F3BFA8",
  warnFill: "#FFF7D1", warnInk: "#6B5600", warnEdge: "#E8D48A",
  okFill: "#E3F3E9", okInk: "#0B4F2E", okEdge: "#A9D9BE", okSolid: "#0E6B3F",
  stageDone: "#8A6D00", stageNot: "#E4E0D7",
  accent: "#FFD108", accentEdge: "#E0B800", accentInk: "#121212",
};
export const MANROPE = { fontFamily: "Manrope, sans-serif" };
export const FOCUS = "focus:outline-none focus:ring-[3px] focus:ring-[#FFD108]/45";

export const TRACK_TAG = {
  LITE: { label: "LITE", fill: "#FFF7D1", ink: "#6B5600", edge: "#E8D48A" },
  GUIDED: { label: "GUIDED", fill: "#F1EEE6", ink: "#59554D", edge: "#DAD5CA" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const ddMon = (iso) => {
  if (!iso) return null;
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]}`;
};

export const days = (iso, today) =>
  Math.round((new Date(`${String(iso).slice(0, 10)}T00:00:00`) - new Date(`${today}T00:00:00`)) / 86400000);

/* The relative line under a target date (§7). */
export const targetLine = (iso, today, wentLive) => {
  if (wentLive) return { text: "went live", color: J.muted, bold: false };
  if (!iso) return { text: "Set a target", color: J.warnInk, bold: true };
  const n = days(iso, today);
  if (n < 0) return { text: `${-n} days past`, color: J.overdue, bold: true };
  if (n === 0) return { text: "Today", color: J.warnInk, bold: true };
  return { text: `in ${n} day${n === 1 ? "" : "s"}`, color: J.muted, bold: false };
};

export const dueLine = (iso, today) => {
  if (!iso) return { text: "No date", color: J.muted, bold: false };
  const n = days(iso, today);
  if (n < 0) return { text: `${ddMon(iso)} · ${-n} days late`, color: J.overdue, bold: true };
  if (n === 0) return { text: `${ddMon(iso)} · today`, color: J.warnInk, bold: true };
  return { text: `${ddMon(iso)} · in ${n} day${n === 1 ? "" : "s"}`, color: J.muted, bold: false };
};

export const initials = (name) =>
  (name || "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

export const SORTS = [
  { key: "target", label: "Target go-live" },
  { key: "next", label: "Next step due" },
  { key: "progress", label: "Least progress" },
  { key: "name", label: "Client A–Z" },
];

/* Live clients always go last (§7 sort rules). */
export const sortRows = (rows, key) => rows.slice().sort((a, b) => {
  if (a.is_live !== b.is_live) return a.is_live ? 1 : -1;
  if (key === "next") return (a.next_action?.due_date || "9999").localeCompare(b.next_action?.due_date || "9999");
  if (key === "progress") return a.stages_completed - b.stages_completed;
  if (key === "name") return (a.company_name || "").localeCompare(b.company_name || "");
  return (a.target_go_live || "9999").localeCompare(b.target_go_live || "9999");
});

/* Panel warnings (§10.4) — derived, never stored. */
export const warningsFor = (r, today) => {
  const w = [];
  if (!r.csm) w.push("No CSM assigned. Journey tasks have no owner in To-dos.");
  if (!r.target_go_live) w.push("No target go-live date set.");
  else if (!r.is_live && days(r.target_go_live, today) < 0)
    w.push(`Target go-live passed ${-days(r.target_go_live, today)} days ago. Set a new target or record the go-live date.`);
  const liveStage = (r.stages || []).find((s) => s.key === "LIVE");
  if (liveStage?.completed && !r.went_live)
    w.push("Go-live step is done but no go-live date is recorded.");
  if (r.hours_over)
    w.push(`Implementation hours are over the ${r.track === "LITE" ? "Lite" : "Guided"} allowance.`);
  return w;
};
